var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "ruleForm",
      staticClass: "orgForm",
      attrs: { model: _vm.ruleForm, rules: _vm.rules, "label-width": "110px" }
    },
    [
      _c(
        "el-form-item",
        { attrs: { label: "公证视频上传", prop: "videoUrl" } },
        [
          _c(
            "el-upload",
            {
              ref: "upload",
              staticClass: "avatar-uploader",
              attrs: {
                action: "#",
                name: "file",
                accept: "video/*",
                "on-change": _vm.onChange,
                "http-request": _vm.upLoadFile,
                "auto-upload": false,
                "on-remove": _vm.handleRemove,
                "file-list": _vm.fileList,
                multiple: false,
                limit: 1
              }
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    disabled: _vm.fileList.length > 0
                  }
                },
                [_vm._v("点击上传")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary", loading: _vm.loading },
              on: {
                click: function($event) {
                  return _vm.submitForm("ruleForm")
                }
              }
            },
            [_vm._v("确认提交视频")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }